var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8333 8.45313V5H7.625C7.26042 5 7 5.2793 7 5.60938V17.3906C7 17.7461 7.26042 18 7.625 18H16.375C16.7135 18 17 17.7461 17 17.3906V9.0625H13.4583C13.0938 9.0625 12.8333 8.80859 12.8333 8.45313ZM14.8125 13.8359L12.3125 16.2734C12.1302 16.4258 11.8438 16.4258 11.6615 16.2734L9.16146 13.8359C8.90104 13.582 9.08333 13.125 9.44792 13.125H11.1667V11.0938C11.1667 10.8906 11.349 10.6875 11.5833 10.6875H12.4167C12.625 10.6875 12.8333 10.8906 12.8333 11.0938V13.125H14.526C14.8906 13.125 15.0729 13.582 14.8125 13.8359ZM16.8177 7.66602L14.2656 5.17773C14.1354 5.07617 13.9792 5 13.8229 5H13.6667V8.25H17V8.09766C17 7.94531 16.9219 7.79297 16.8177 7.66602Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.de6f83e240e9ef2f5b26151894a36350.svg";
export { ForwardRef as ReactComponent };